"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleImageCard = exports.OopsCard = exports.DeniedCard = exports.ConfirmCard = exports.WarningCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const DoneAction_1 = require("../../survey/actions/DoneAction");
const CardHelper_1 = require("../utils/CardHelper");
const WarningCard = (title, applicationType) => SimpleImageCard(title, "WARN", applicationType);
exports.WarningCard = WarningCard;
const ConfirmCard = (title, applicationType) => SimpleImageCard(title, "CONFIRM", applicationType);
exports.ConfirmCard = ConfirmCard;
const DeniedCard = (title, applicationType) => SimpleImageCard(title, "DENIED", applicationType);
exports.DeniedCard = DeniedCard;
const OopsCard = (title, applicationType) => SimpleImageCard(title, "OOPS", applicationType);
exports.OopsCard = OopsCard;
function SimpleImageCard(title, type, applicationType, cancelLabel) {
    const card = CardHelper_1.CardHelper.newCard();
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.ExtraLarge,
        text: title,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        spacing: adaptivecards_1.Spacing.Large,
        size: adaptivecards_1.Size.Auto,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        url: (0, CardHelper_1.getImageCardUrl)(type, applicationType),
    }));
    card.addItem(container);
    card.addAction((0, DoneAction_1.DoneAction)(cancelLabel));
    return card;
}
exports.SimpleImageCard = SimpleImageCard;
//# sourceMappingURL=SimpleImageCard.js.map